
import "./Message.css";
import Icon from "./Icon";
export default function Message(props) {
    return (
      <div className="message">
      <div className="container">
        <Icon name={props.name}/>
        <span>{props.text}</span>
      </div>
      </div>
    );
  }
Message.defaultProps={
  text:"Coding In Progress"
}